import React from 'react';
import Features from './Features';
import Advantages from './Advantages';
import { FAQ } from '../FAQ/faqs';
import Footer from '../Footer';





function FleetManagement() {
  return (
    <>
<Features docname="Fleet Management"/>
<Advantages docname="Fleet Management"/>
<FAQ category="About Accxchange"/>
<Footer segment="Smarty Home"/>
    </>
  );
}

export default FleetManagement;
